import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { DevicesActions } from "../_actions/DevicesActions";
import { MainPageWithButtons, WaitSpinner } from "../_components";
import { genericActions } from "../_helpers/ActionErrorWrapper";
import { DeviceSearchResultsTable } from "../ModuleDeviceSearch/DeviceSearchResultsTable";

export function LocationDeviceDetail({ bluetoothId }) {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [devices, setDevices] = useState(null);

    useEffect(() => {
        let isCurrent = true;
        setDevices(null);
        dispatch(DevicesActions.getDeviceByBluetoothId(bluetoothId)).then((foundDevices) => {
            if (isCurrent)
                setDevices(foundDevices ?? []);
        }).catch((error) => {
            dispatch(genericActions.errorCatch(error));
        });
        return () => { isCurrent = false; };
    }, [dispatch, bluetoothId]);

    return (
        <MainPageWithButtons
            pageTitle={t("mod_device_search_title")}
            content={devices ? <DeviceSearchResultsTable devices={devices} /> : <WaitSpinner />}
            size={'X_LARGE'}
        />
    );
}
